import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  List,
  ListItem,
  ListItemText,
  TablePagination,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MASK_TYPE, PersonalClient } from "types";
import styled from "styled-components";
import { PersonalCLientSearchProps } from "pages/clientPortfolio/businessClient/businessClientInformation/components/PersonalClientSearch";
import { useEffect, useState } from "react";
import AddressDisplayer from "components/fields/AddressDisplay";
import MaskedValue from "common/MaskedValue";
import { getPersonalClientName } from "common/functions";

const PersonalClientList = (props: PersonalCLientSearchProps) => {
  //setting page to 0(1st page) if the filtered list is changed
  //to have correct filtering user experience
  useEffect(() => {
    setPage(0);
  }, [props.personalClients]);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);

  if (!props.personalClients || props.personalClients.length === 0) {
    return <Content>There are no clients.</Content>;
  }

  return (
    <div>
      <List>
        {props.personalClients
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((c, index) => {
            return (
              <ListItem key={index} style={{ alignItems: "center" }}>
                <ListItemText primary={<PrimaryText personalClient={c} />} />
                <Button
                  variant="contained"
                  style={{ margin: "0 0 0 1em" }}
                  onClick={() => {
                    props.onPersonalClientSelected &&
                      props.onPersonalClientSelected(c);
                  }}
                >
                  Select
                </Button>
              </ListItem>
            );
          })}
      </List>
      <TablePagination
        sx={{ zIndex: 200000 }}
        rowsPerPageOptions={[5, 10]}
        component="div"
        count={props.personalClients.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(e, p) => {
          setPage(p);
        }}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(+e.target.value);
        }}
      />
    </div>
  );
};

const PrimaryText = (props: { personalClient: PersonalClient }) => {
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        style={{ marginRight: "0.5em" }}
        id={props.personalClient.identification?.clientId + " - header"}
      >
        <RowSection>
          <PrimaryTextSection width={"small"}>
            {props.personalClient.identification?.clientId}{" "}
          </PrimaryTextSection>
          <PrimaryTextSection width={"wide"}>
            {getPersonalClientName(props.personalClient)}
          </PrimaryTextSection>
          <PrimaryTextSection width={"med"}>
            {MaskedValue(
              MASK_TYPE.PHONE_NUMBER,
              props.personalClient.information?.phoneNumber ?? ""
            )}
          </PrimaryTextSection>
        </RowSection>
      </AccordionSummary>
      <AccordionDetails>
        <AddressDisplayer
          address={props.personalClient.information?.clientCurrentAddress ?? {}}
          displayAddressLabel={true}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default PersonalClientList;

const PrimaryTextSection = styled.div<{ width: "small" | "med" | "wide" }>`
  width: ${(p) =>
    p.width === "med" ? "125px" : p.width === "wide" ? "160px" : "100px"};
  padding: 0px 10px;
  word-wrap: break-word;
`;

const Content = styled.div`
  margin-left: 1.5em;
`;

const RowSection = styled.div`
  display: flex;
  align-items: center;
`;
